import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';

import Input from 'af-fields/Input';

import BackButton from 'af-components/BackButton';
import SubmitButton from 'af-components/SubmitButton';

interface OwnProps {
	disabled: boolean;
	submitting: boolean;
	isDefaultWageRate?: boolean;
}

type Props = OwnProps;

export default class WageRateForm extends React.PureComponent<Props> {
	render() {
		const {
			submitting,
			disabled,
			isDefaultWageRate,
		} = this.props;

		return (
			<div className="form-box">
				<Row className="row--padded-top">
					<Col sm={12}>
						<Field
							component={Input}
							disabled={isDefaultWageRate}
							isRequired={true}
							label="Labor Type"
							name="type"
							placeholder="Enter Labor Type"
							type="text"
						/>
					</Col>
					<Col sm={12}>
						<Field
							component={Input}
							disabled={isDefaultWageRate}
							isRequired={true}
							label="Wage Classification"
							name="wageClassification"
							placeholder="Enter Wage Classification"
							type="text"
						/>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<Field
							addonAfter="$"
							component={Input}
							isRequired={true}
							isZeroIfEmpty={true}
							label="Hourly Rate"
							name="hourlyRate"
							placeholder="Enter Hourly Rate"
							type="number"
							withThousandsSeparator={true}
						/>
					</Col>
					<Col sm={12} />
				</Row>
				<Row className="row--submit">
					<BackButton />
					<SubmitButton
						disabled={disabled}
						reduxFormSubmitting={submitting}
						variant="primary"
					/>
				</Row>
			</div>
		);
	}
}
